/* Calvora Carry — product page logic */
(function () {
  'use strict';

  /* ---------- money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var fmt = format || window.moneyFormat || '${{amount}}';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;

    function defaultTo(v, d) { return v == null || v === '' ? d : v; }
    function formatWithDelimiters(num, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ',');
      decimal = defaultTo(decimal, '.');
      if (isNaN(num) || num === null) return 0;
      num = (num / 100.0).toFixed(precision);
      var parts = num.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cts = parts[1] ? decimal + parts[1] : '';
      return dollars + cts;
    }

    var value = '';
    var match = fmt.match(placeholder);
    var key = match ? match[1] : 'amount';

    switch (key) {
      case 'amount': value = formatWithDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = formatWithDelimiters(cents, 2, "'", '.'); break;
      default: value = formatWithDelimiters(cents, 2);
    }
    return fmt.replace(placeholder, value);
  }

  /* ---------- gallery ---------- */
  function initGallery(root) {
    var stage = root.querySelector('[data-stage]');
    if (!stage) return null;
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-slide]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-thumb]'));
    var index = 0;

    function show(i) {
      if (!slides.length) return;
      index = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === index); });
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === index); });
    }

    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { show(n); }); });
    var prev = root.querySelector('[data-stage-prev]');
    var next = root.querySelector('[data-stage-next]');
    if (prev) prev.addEventListener('click', function () { show(index - 1); });
    if (next) next.addEventListener('click', function () { show(index + 1); });

    var zoom = root.querySelector('[data-stage-zoom]');
    if (zoom) {
      zoom.addEventListener('click', function () {
        var img = slides[index] && slides[index].querySelector('img');
        if (img) window.open(img.currentSrc || img.src, '_blank', 'noopener');
      });
    }

    /* swipe */
    var x0 = null;
    stage.addEventListener('touchstart', function (e) { x0 = e.changedTouches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 45) show(dx < 0 ? index + 1 : index - 1);
      x0 = null;
    }, { passive: true });

    return {
      showByImageSrc: function (src) {
        if (!src) return;
        var id = src.split('?')[0].split('/').pop().split('.')[0];
        for (var i = 0; i < slides.length; i++) {
          var img = slides[i].querySelector('img');
          if (img && img.src.indexOf(id) !== -1) { show(i); return; }
        }
      }
    };
  }

  /* ---------- product ---------- */
  function initProduct(root) {
    var variantsEl = root.querySelector('[data-variants]');
    var metaEl = root.querySelector('[data-product-meta]');
    if (!variantsEl) return;

    var variants = JSON.parse(variantsEl.textContent || '[]');
    var meta = metaEl ? JSON.parse(metaEl.textContent || '{}') : {};
    var gallery = initGallery(root);

    var priceEl = root.querySelector('[data-total-price]');
    var compareEl = root.querySelector('[data-compare-price]');
    var saveBadgeEl = root.querySelector('[data-save-badge]');
    var priceRowEl = root.querySelector('[data-forced-pct]');
    var forcedPct = priceRowEl ? parseInt(priceRowEl.getAttribute('data-forced-pct'), 10) || 0 : 0;

    /* struck-through price for a given selling price */
    function compareFor(now, qty) {
      if (forcedPct > 0 && forcedPct < 100) return Math.round(now * 100 / (100 - forcedPct));
      return current && current.compare_at_price ? current.compare_at_price * qty : 0;
    }
    var stockEl = root.querySelector('[data-stock]');
    var atcButtons = Array.prototype.slice.call(root.querySelectorAll('[data-atc], [data-atc-sticky]'));
    var optionButtons = Array.prototype.slice.call(root.querySelectorAll('[data-option-value]'));
    var bundles = Array.prototype.slice.call(root.querySelectorAll('[data-bundle]'));
    var addons = Array.prototype.slice.call(root.querySelectorAll('[data-addon]'));
    var engraveToggle = root.querySelector('[data-engrave-toggle]');
    var engraveField = root.querySelector('[data-engrave-field]');
    var engraveInput = root.querySelector('[data-engrave-input]');
    var engravePrice = parseInt(root.getAttribute('data-engrave-price') || '0', 10) || 0;
    var cartUrl = root.getAttribute('data-cart-url') || '/cart';

    var engraveOn = false;
    var current = null;

    function selectedOptions() {
      var out = [];
      root.querySelectorAll('[data-option-block]').forEach(function (block) {
        var pos = parseInt(block.getAttribute('data-option-position'), 10);
        var active = block.querySelector('[data-option-value].is-active');
        if (active) out[pos - 1] = active.getAttribute('data-option-value');
      });
      return out;
    }

    function findVariant() {
      var sel = selectedOptions();
      if (!sel.length) return variants[0];
      return variants.find(function (v) {
        return sel.every(function (val, i) { return val == null || v.options[i] === val; });
      }) || null;
    }

    function activeBundle() { return bundles.find(function (b) { return b.classList.contains('is-active'); }) || null; }

    function addonTotal() {
      return addons.reduce(function (sum, a) {
        return a.classList.contains('is-on') ? sum + (parseInt(a.getAttribute('data-price'), 10) || 0) : sum;
      }, 0);
    }

    function refreshBundlePrices() {
      if (!current) return;
      bundles.forEach(function (b) {
        var fixed = parseInt(b.getAttribute('data-fixed-price'), 10) || 0;
        var qty = parseInt(b.getAttribute('data-qty'), 10) || 1;
        var el = b.querySelector('[data-bundle-price]');
        var now = fixed > 0 ? fixed : current.price * qty;
        if (el && !fixed) el.textContent = formatMoney(now);

        var cmp = b.querySelector('[data-bundle-compare]');
        if (cmp) {
          var fixedCmp = parseInt(cmp.getAttribute('data-fixed-compare'), 10) || 0;
          var was = fixedCmp > 0 ? fixedCmp : compareFor(now, qty);
          if (was > now) {
            cmp.textContent = formatMoney(was);
            cmp.removeAttribute('hidden');
          } else {
            cmp.setAttribute('hidden', '');
          }
        }
      });
    }

    function total() {
      if (!current) return 0;
      var b = activeBundle();
      var qty = b ? parseInt(b.getAttribute('data-qty'), 10) || 1 : 1;
      var fixed = b ? parseInt(b.getAttribute('data-fixed-price'), 10) || 0 : 0;
      var base = fixed > 0 ? fixed : current.price * qty;
      return base + addonTotal() + (engraveOn ? engravePrice : 0);
    }

    function markUnavailable() {
      var sel = selectedOptions();
      optionButtons.forEach(function (btn) {
        var pos = parseInt(btn.getAttribute('data-option-position'), 10) - 1;
        var test = sel.slice();
        test[pos] = btn.getAttribute('data-option-value');
        var match = variants.find(function (v) {
          return test.every(function (val, i) { return val == null || v.options[i] === val; });
        });
        btn.classList.toggle('is-disabled', !match || !match.available);
      });
    }

    function render() {
      current = findVariant();
      var t = total();

      if (priceEl) priceEl.textContent = current ? formatMoney(t) : '';

      /* compare-at (original) price + discount badge */
      if (compareEl) {
        var b2 = activeBundle();
        var qty2 = b2 ? parseInt(b2.getAttribute('data-qty'), 10) || 1 : 1;
        var bFixedCmpEl = b2 ? b2.querySelector('[data-bundle-compare]') : null;
        var bFixedCmp = bFixedCmpEl ? parseInt(bFixedCmpEl.getAttribute('data-fixed-compare'), 10) || 0 : 0;
        var compare = bFixedCmp > 0 ? bFixedCmp : compareFor(t, qty2);
        if (compare > t) {
          compareEl.textContent = formatMoney(compare);
          compareEl.removeAttribute('hidden');
          if (saveBadgeEl) {
            saveBadgeEl.textContent = '-' + Math.round((compare - t) / compare * 100) + '%';
            saveBadgeEl.removeAttribute('hidden');
          }
        } else {
          compareEl.setAttribute('hidden', '');
          if (saveBadgeEl) saveBadgeEl.setAttribute('hidden', '');
        }
      }
      if (stockEl) {
        if (current && current.available) {
          stockEl.textContent = meta.stockText || 'In stock';
          stockEl.classList.remove('is-out');
        } else {
          stockEl.textContent = current ? (meta.soldOutText || 'Sold out') : (meta.unavailableText || 'Unavailable');
          stockEl.classList.add('is-out');
        }
      }

      atcButtons.forEach(function (btn) {
        var label = btn.querySelector('[data-atc-label]');
        var pr = btn.querySelector('[data-atc-price]');
        var ok = !!(current && current.available);
        btn.disabled = !ok;
        if (label) label.textContent = ok ? (meta.addText || 'Add to cart') : (current ? (meta.soldOutText || 'Sold out') : (meta.unavailableText || 'Unavailable'));
        if (pr) pr.textContent = ok ? ' — ' + formatMoney(t) : '';
      });

      var selectedLabel = root.querySelector('[data-option-selected]');
      if (selectedLabel) {
        var sw = root.querySelector('.swatch.is-active');
        if (sw) selectedLabel.textContent = sw.getAttribute('data-option-value');
      }

      refreshBundlePrices();
      markUnavailable();

      if (current && current.featured_image && gallery) gallery.showByImageSrc(current.featured_image.src);

      if (current && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', current.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    /* events */
    optionButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var block = btn.closest('[data-option-block]');
        block.querySelectorAll('[data-option-value]').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        render();
      });
    });

    bundles.forEach(function (b) {
      b.addEventListener('click', function () {
        bundles.forEach(function (x) { x.classList.remove('is-active'); });
        b.classList.add('is-active');
        render();
      });
    });

    addons.forEach(function (a) {
      var sw = a.querySelector('.addon__switch');
      function toggle() {
        a.classList.toggle('is-on');
        if (sw) sw.setAttribute('aria-checked', a.classList.contains('is-on') ? 'true' : 'false');
        render();
      }
      if (sw) sw.addEventListener('click', toggle);
      a.addEventListener('click', function (e) { if (e.target !== sw && !sw.contains(e.target)) toggle(); });
    });

    if (engraveToggle) {
      engraveToggle.addEventListener('click', function () {
        engraveOn = !engraveOn;
        engraveToggle.classList.toggle('is-on', engraveOn);
        if (engraveField) engraveField.classList.toggle('is-open', engraveOn);
        if (engraveOn && engraveInput) engraveInput.focus();
        render();
      });
    }

    /* add to cart */
    function buildItems() {
      if (!current) return [];
      var b = activeBundle();
      var qty = b ? parseInt(b.getAttribute('data-qty'), 10) || 1 : 1;
      var props = {};
      if (engraveOn && engraveInput && engraveInput.value.trim()) {
        props[meta.engravingLabel || 'Engraving'] = engraveInput.value.trim();
      }
      var items = [{ id: current.id, quantity: qty }];
      if (Object.keys(props).length) items[0].properties = props;

      if (b && b.getAttribute('data-extra-variant')) {
        items.push({ id: parseInt(b.getAttribute('data-extra-variant'), 10), quantity: 1 });
      }
      addons.forEach(function (a) {
        var id = a.getAttribute('data-variant');
        if (a.classList.contains('is-on') && id) items.push({ id: parseInt(id, 10), quantity: 1 });
      });
      return items;
    }

    atcButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var items = buildItems();
        if (!items.length) return;
        btn.classList.add('is-loading');
        fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (data && data.status && data.status !== 200) throw new Error(data.description || data.message);
            window.location.href = cartUrl;
          })
          .catch(function (err) {
            btn.classList.remove('is-loading');
            alert(err.message || 'Could not add to cart.');
          });
      });
    });

    render();
  }

  function boot() {
    document.querySelectorAll('[data-product-root]').forEach(initProduct);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', boot);
})();
